module.exports = __webpack_public_path__ + "static/media/icon_event_local_mer.1316169a.svg";